import * as React from "react";
import { useTranslation } from "react-i18next";
import logo from "assets/images/logo.png";
import logoMeta from "assets/images/metaverse-logo-sm.png";
import logoAsobi from "assets/images/asobi-system.png";
import logoUpbond from "assets/images/upbond.png";
import logoGenie from "assets/images/genie.png";

const links = [
  { label: "TOP", url: "https://www.city-pop.tokyo" },
  { label: "about", url: "https://www.city-pop.tokyo/about" },
  { label: "road map", url: "https://www.city-pop.tokyo/roadmap" },
];

const legalLinks = [
  { label: "privacy_policy", url: "https://www.city-pop.tokyo/privacy-policy" },
  { label: "term_of_use", url: "https://www.city-pop.tokyo/term-of-use" },
  {
    label: "social_commercial",
    url: "https://www.city-pop.tokyo/special-commercial",
  },
];

function Logo() {
  return <img loading="lazy" src={logo} alt="Company logo" className="w-64" />;
}
function Supported() {
  return (
    <div className="sm:flex grid items-end text-center support-wrapper">
      <img
        loading="lazy"
        src={logoMeta}
        alt="Company logo"
        className="h-12 sm:m-[unset] m-auto support meta"
      />
      <img
        loading="lazy"
        src={logoAsobi}
        alt="Company logo"
        className="h-12 sm:m-[unset] m-auto support"
      />
      <img
        loading="lazy"
        src={logoUpbond}
        alt="Company logo"
        className="h-10 sm:m-[unset] m-auto support"
      />
      <img
        loading="lazy"
        src={logoGenie}
        alt="Company logo"
        className="h-10 sm:m-[unset] m-auto support"
      />
    </div>
  );
}

function NavLinks() {
  return (
    <nav className="mt-8">
      {links.map((link) => (
        <div key={link.label} className="mt-5 first:mt-0">
          <a className="gothic" href={link.url}>
            {link.label}
          </a>
        </div>
      ))}
    </nav>
  );
}

function LegalLinks() {
  const { t, i18n } = useTranslation();
  return (
    <div className="flex flex-col self-end mt-44 text-base text-center whitespace-nowrap max-md:mt-10 m-auto md:m-[unset]">
      <div className="flex flex-col md:pl-5">
        {legalLinks.map((link) => (
          <div
            key={link.label}
            className={`mt-5 first:mt-0 ${
              link.label === "プライバシーポリシー"
                ? "self-start"
                : "md:self-end"
            }`}
          >
            <a className="gothic" href={link.url}>
              {t(link.label)}
            </a>
          </div>
        ))}
      </div>
      {/* <div className="self-start mt-5 ml-5 max-md:ml-2.5">
        <a href={legalLinks[2].url}>{legalLinks[2].label}</a>
      </div> */}
    </div>
  );
}

export default function Footer() {
  const [isMobile, setIsMobile] = React.useState(false);

  React.useLayoutEffect(() => {
    function updateSize() {
      if (window.innerWidth > 500 && window.innerWidth < 1279) {
        setIsMobile(true);
      } else {
        setIsMobile(false);
      }
    }
    window.addEventListener("resize", updateSize);
    updateSize();
    return () => window.removeEventListener("resize", updateSize);
  }, []);

  return (
    <footer className="flex md:justify-center items-center w-full md:max-w-[1600px] md:mx-auto md:px-16 py-20 text-white bg-purple-500 max-md:px-5">
      <div className="md:flex grid gap-5 md:justify-between w-full max-md:flex-wrap max-md:max-w-full">
        <div className="flex flex-col text-2xl m-auto md:m-[unset]">
          <Logo />
          {/* {!isMobile && <NavLinks />} */}
          {isMobile && <div className="mt-8"><Supported /></div>}
        </div>
        {!isMobile && <Supported />}
        <LegalLinks />
      </div>
    </footer>
  );
}
